import { c as _c } from "react/compiler-runtime";
import { FB_EVENTS, sendFBEvent } from 'commons/fbEvents';
import { logError } from 'commons/logger';
import { useEffect } from 'react';
import useMetaFormattedCityStateZip from '../useMetaFormattedCityStateZip';
const DEFAULT_BASIC_DETAILS = {};
const DEFAULT_VARIANT_SKU = '';
const useJbEventFBAddToCart = t0 => {
  const $ = _c(15);
  const {
    basicDetails: t1,
    selectedOptionsVariantSku: t2
  } = t0;
  const basicDetails = t1 === undefined ? DEFAULT_BASIC_DETAILS : t1;
  const selectedOptionsVariantSku = t2 === undefined ? DEFAULT_VARIANT_SKU : t2;
  const {
    formattedZip: zip,
    formattedCity: city,
    formattedState: state
  } = useMetaFormattedCityStateZip();
  let t3;
  if ($[0] !== basicDetails || $[1] !== city || $[2] !== selectedOptionsVariantSku || $[3] !== state || $[4] !== zip) {
    t3 = () => {
      const sku = basicDetails?.sku ? basicDetails.sku + selectedOptionsVariantSku : null;
      window.jbEventFBAddToCart = () => {
        if (basicDetails?.sku) {
          sendFBEvent(FB_EVENTS.ADD_TO_CART, {
            content_category: basicDetails?.type?.name,
            content_ids: [sku],
            content_name: basicDetails?.name,
            content_type: "product",
            currency: "USD",
            value: basicDetails?.meta?.price?.final_price,
            zp: zip,
            ct: city,
            st: state
          });
        } else {
          logError(new Error("window.jbEventFBAddToCart: missing sku"));
        }
      };
    };
    $[0] = basicDetails;
    $[1] = city;
    $[2] = selectedOptionsVariantSku;
    $[3] = state;
    $[4] = zip;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = basicDetails?.sku;
  const t5 = basicDetails?.type?.name;
  const t6 = basicDetails?.name;
  const t7 = basicDetails?.meta?.price?.final_price;
  let t8;
  if ($[6] !== city || $[7] !== selectedOptionsVariantSku || $[8] !== state || $[9] !== t4 || $[10] !== t5 || $[11] !== t6 || $[12] !== t7 || $[13] !== zip) {
    t8 = [t4, t5, t6, t7, city, selectedOptionsVariantSku, state, zip];
    $[6] = city;
    $[7] = selectedOptionsVariantSku;
    $[8] = state;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = zip;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  useEffect(t3, t8);
};
export default useJbEventFBAddToCart;